export var WIDGET_TYPE;
(function (WIDGET_TYPE) {
    WIDGET_TYPE["PROPERTY"] = "property";
    WIDGET_TYPE["AMENITY"] = "amenity";
})(WIDGET_TYPE || (WIDGET_TYPE = {}));
export const getPropertyWidgetEmbedCode = (widgetUrl) => {
    return `<iframe src="${widgetUrl}" frameborder="0" allowfullscreen></iframe>`;
};
export const getPropertyWidgetUrl = (type, searchConfig) => {
    const widgetUrl = new URL((type === "property" && "propertyGrid") || "amenities", process.env.PEEK_APP_WIDGETS_URL);
    widgetUrl.search = new URLSearchParams(searchConfig).toString();
    return widgetUrl;
};
